import styled from 'src/style';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import AnchorLink from 'react-anchor-link-smooth-scroll';

export const Timeline = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  width: '100%',
  [mediaQueries.tabletLandscapeUp]: {
    flexDirection: 'row',
    marginBottom: 30,
  },
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 4,
    backgroundColor: colors.yellow,
    top: 0,
    bottom: 0,
    left: '50%',
    marginLeft: '-2px',
    '&:last-child:after': {
      content: 'none',
    },
    [mediaQueries.tabletLandscapeUp]: {
      left: 0,
      right: 0,
      top: 80,
      height: 4,
      width: '100%',
      bottom: 'auto',
    },
  },
});

export const DottedTimeline = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  '&:after': {
    content: '""',
    position: 'absolute',
    height: 5,
    left: 0,
    right: 120,
    top: 80,
  },
});

export const TimelineContent = styled.div(
  {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    marginBottom: 25,
    width: '50%',
    [mediaQueries.tabletLandscapeUp]: {
      marginLeft: 0,
      marginBottom: 0,
      width: '100%',
    },
  },
  ({ right }) => ({
    left: right ? '50%' : 0,
    padding: '0 20px',

    [mediaQueries.tabletLandscapeUp]: {
      left: 0,
      padding: 0,
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 15,
      height: 15,
      top: 40,
      border: `4px solid ${colors.yellow}`,
      backgroundColor: colors.purpleDark,
      borderRadius: '50%',
      zIndex: 1,
      left: right ? '-7px' : 'auto',
      right: right ? 'auto' : '-7px',
      [mediaQueries.tabletLandscapeUp]: {
        top: 75,
        left: 'auto',
        right: 'auto',
      },
    },
  })
);

export const TimelineText = styled.div({
  marginTop: 0,
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  paddingLeft: 0,
  paddingRight: 0,

  [mediaQueries.tabletLandscapeUp]: {
    marginTop: 40,
    paddingLeft: 20,
    paddingRight: 20,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
});

export const TimelineIcon = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingBottom: 20,

  height: 67,
  [mediaQueries.tabletLandscapeUp]: {
    height: 77,
    paddingBottom: 40,
  },
});

export const StyledSmoothAnchor = styled(AnchorLink)(
  {
    fontSize: 17,
    lineHeight: '22px',
    paddingLeft: 5,
    textDecoration: 'none',
    color: colors.yellow,
    cursor: 'pointer',
  },
  ({ theme }) => ({
    ...theme.fonts.HKCompakt.bold,
  })
);
